module.exports = __webpack_public_path__ + "static/img/LOGO.b172fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/LOGO.png
// module id = ieuC
// module chunks = 1